import { render } from "./AddServiceLocationForm.vue?vue&type=template&id=64f0f90c"
import script from "./AddServiceLocationForm.ts?vue&type=script&lang=js&external"
export * from "./AddServiceLocationForm.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__